import React, { useEffect, useState } from "react";
import Hamburger from "../assets/images/hamburger.png";
import HamburgerBlue from "../assets/images/hamburgerBlue.svg";
import Graph from "../assets/images/data.svg";
import GraphWhite from "../assets/images/datawhite.svg";
import { Col, Container, Dropdown, Form, Row, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import Page from "./Page";
import ChartComponent from "../common/Chart";
import { apiRequest } from "../utils/comman/apiRequest";
import { Urls } from "../utils/endPoints/apiUrls";
import { fDate } from "../utils/fileHelper";
import Pagination from "./comman/Pagination";
import Loader from "./comman/Loader";
import { fetchFlashData } from "../redux/actions/flashActions";

export default function SleepwellPrice() {
  const [brandData, setBrandData] = useState([]);
  const [materialDropDown, setMaterialDropDown] = useState([]);
  const [materialData, setMaterialData] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [grapMaterialData, setGrapMaterialData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDashLoaded, setIsDashLoaded] = useState(false);
  const [isChartLoaded, setIsChartLoaded] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  function calculateComparisonPercent(brands, baseBrand) {
    // Find base brand avgPrice
    const baseBrandData = brands.find((b) => b.brand === baseBrand);
    const baseAvgPrice = baseBrandData ? baseBrandData.avgPrice : 0;

    // Calculate comparison % for each brand, excluding the base brand
    return brands
      .filter(({ brand }) => brand !== baseBrand)
      .map(({ brand, avgPrice }) => {
        let comparisonPercent = 0;
        if (baseAvgPrice > 0) {
          comparisonPercent = ((avgPrice - baseAvgPrice) / avgPrice) * 100;
        }
        return {
          brand,
          avgPrice,
          comparisonPercent: parseFloat(comparisonPercent.toFixed(2)),
        };
      });
  }

  const fetchMaterialDropdown = async () => {
    const { data, status } = await apiRequest({
      method: "GET",
      endUrl: Urls.materialDropDown,
    });
    if (status) {
      setMaterialDropDown(data.rows);
    }
  };

  const [filters, setFilters] = useState({
    baseBrand: "Sleepwell",
    startDate: new Date(),
    endDate: new Date(),
    selectedMaterials: ["Dual"],
    marketplace: "Amazon",
  });

  // const toggleSelection = (value, key) => {
  //   setFilters((prev) => {
  //     const currentArray = prev[key];
  //     const updatedArray = currentArray.includes(value)
  //       ? currentArray.filter((v) => v !== value)
  //       : [...currentArray, value];

  //     return {
  //       ...prev,
  //       [key]: updatedArray,
  //     };
  //   });
  // };

  // const toggleSelection = (value, key) => {
  //   setFilters((prev) => ({
  //     ...prev,
  //     [key]: [value],
  //   }));
  // };
  const toggleSelection = (value, key) => {
    setFilters((prev) => {
      const selectedArray = prev[key];
      const alreadySelected = selectedArray.includes(value);

      return {
        ...prev,
        [key]: alreadySelected
          ? selectedArray.filter((v) => v !== value) // remove it
          : [...selectedArray, value], // add it
      };
    });
  };

  const [active, setActive] = useState("list");
  const isActive = (key) => active === key;

  //to get the listing
  const fetchMaterialData = async (customFilters = filters) => {
    setIsLoading(true);
    setIsDashLoaded(true);

    const query = {
      startDate: customFilters.startDate,
      endDate: customFilters.endDate,
      material: customFilters?.selectedMaterials?.[0] || "",
      baseBrand: customFilters?.baseBrand,
      marketplace: customFilters.marketplace || "",
    };

    const { data, status } = await apiRequest({
      method: "GET",
      endUrl: Urls.materialData,
      query: { ...query, ...pagination },
    });
    if (status) {
      setIsLoading(false);
      setIsDashLoaded(false);

      setMaterialData({
        ...materialData,
        count: pagination?.page == 1 ? data?.total : materialData.count,
        limit: data?.limit,
        page: data?.page,
        rows: data.rows,
      });
      const brandsWithComparison = calculateComparisonPercent(
        data.brands,
        filters.baseBrand
      );
      setBrandData(brandsWithComparison);
    }
  };

  // to get dash material %
  // const fetchKurlonDash = async () => {
  //   const { data, status } = await apiRequest({
  //     method: "GET",
  //     endUrl: Urls.materials,
  //     query: filters
  //   })
  //   if (status) {
  //     extractBrandPercentages(data.rows);
  //   }
  // }

  //to get the graph data
  const fetchGraphMaterialData = async (customFilters = filters) => {
    setIsChartLoaded(true);
    const query = {
      startDate: customFilters.startDate,
      endDate: customFilters.endDate,
      material: customFilters.selectedMaterials?.[0] || "",
      baseBrand: customFilters.baseBrand,
      marketplace: customFilters.marketplace || "",
    };
    const { data, status } = await apiRequest({
      method: "GET",
      endUrl: Urls.graphMaterial,
      query: { ...query },
    });
    if (status) {
      setIsChartLoaded(false);

      setGrapMaterialData(data.rows);
    }
  };

  useEffect(() => {
    fetchMaterialData();
    fetchMaterialDropdown();
    fetchGraphMaterialData();
  }, [filters, pagination]);

  const [dropdowns, setDropdowns] = useState({
    material: false,
    type: false,
    size: false,
    marketplace: false,
  });

  const handleDropdownToggle = (key, isOpen) => {
    setDropdowns((prev) => ({ ...prev, [key]: isOpen }));
  };

  const closeDropdown = (key) => {
    setDropdowns((prev) => ({ ...prev, [key]: false }));
  };

  return (
    <Page
      title={"Sleepwell Price Comparision"}
      subtitle={"Dashboard > Sleepwell Price Comparision"}
    >
      <Container>
        <Row className="mt-4">
          <Col md={8}>
            <Row className="align-items-center g-0 filterrow">
              <Col>
                <div className="d-flex align-items-center">
                  <Form.Label className="mb-0 filterText me-1 ms-2">
                    Start Date:
                  </Form.Label>
                  <DatePicker
                    selected={filters.startDate}
                    onChange={(newDate) =>
                      setFilters((prev) => ({ ...prev, startDate: newDate }))
                    }
                    selectsStart
                    startDate={filters.startDate}
                    endDate={filters.endDate}
                    dateFormat="dd MMMM yyyy"
                    className="form-control date-formcontrol"
                  />
                  <Form.Label className="mb-0 filterText me-1 ms-2">
                    End Date:
                  </Form.Label>
                  <DatePicker
                    selected={filters.endDate}
                    onChange={(newDate) =>
                      setFilters((prev) => ({ ...prev, endDate: newDate }))
                    }
                    selectsEnd
                    startDate={filters.startDate}
                    endDate={filters.endDate}
                    dateFormat="dd MMMM yyyy"
                    className="form-control date-formcontrol"
                  />
                </div>
              </Col>

              <Col>
                <Dropdown
                  show={dropdowns.material}
                  onToggle={(isOpen) =>
                    handleDropdownToggle("material", isOpen)
                  }
                >
                  <Dropdown.Toggle
                    variant="outline-secondary dropbtn"
                    style={{
                      borderRight: 0,
                      borderTopRightRadius: 8,
                      borderBottomRightRadius: 8,
                    }}
                  >
                    Material:{" "}
                    <span className="droptxt">
                      {filters.selectedMaterials[0] || "Select"}
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Form.Label className="px-3 filterText">
                      Select Material
                    </Form.Label>
                    {materialDropDown?.map((mat) => (
                      <Form.Check
                        key={mat.name}
                        type="checkbox"
                        label={mat.name}
                        checked={filters.selectedMaterials.includes(mat.name)}
                        // onChange={() => toggleSelection(mat.name, "selectedMaterials")}
                        onChange={() => {
                          toggleSelection(mat?.name, "selectedMaterials");
                          closeDropdown("material");
                        }}
                      />
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>

              <Col>
                <Dropdown
                  show={dropdowns.marketplace}
                  onToggle={(isOpen) =>
                    handleDropdownToggle("marketplace", isOpen)
                  }
                >
                  <Dropdown.Toggle
                    variant="outline-secondary dropbtn"
                    style={{
                      borderRight: 0,
                      borderTopRightRadius: 8,
                      borderBottomRightRadius: 8,
                    }}
                  >
                    Marketplace:{" "}
                    <span className="droptxt">
                      {filters.marketplace || "Select"}
                    </span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Form.Label className="px-3 filterText">
                      Select Marketplace
                    </Form.Label>
                    {["Amazon", "Flipkart"].map((market) => (
                      <Form.Check
                        key={market}
                        type="checkbox"
                        label={market}
                        checked={filters.marketplace === market}
                        onChange={() => {
                          setFilters((prev) => {
                            const isSame = prev.marketplace === market;
                            return {
                              ...prev,
                              marketplace: isSame ? "Amazon" : market, // fallback to Amazon if same clicked
                            };
                          });
                          closeDropdown("marketplace");
                        }}
                      />
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
            </Row>
          </Col>

          <Col md={4} className="d-flex justify-content-end">
            <div className="d-flex">
              <Button
                variant="light"
                onClick={() => setActive("graph")}
                className="sleepwell-btn"
                style={{
                  backgroundColor: isActive("graph") ? "#241F6D" : "#fff",
                  border: isActive("graph") ? "none" : "1px solid #241F6D",
                }}
              >
                {isActive("graph") ? (
                  <img src={GraphWhite} alt="" />
                ) : (
                  <img src={Graph} alt="" />
                )}
              </Button>

              <Button
                variant="light"
                onClick={() => setActive("list")}
                className="sleepwell-btn ms-2"
                style={{
                  backgroundColor: isActive("list") ? "#241F6D" : "#fff",
                  color: isActive("list") ? "#fff" : "#241F6D",
                  border: isActive("list") ? "none" : "1px solid #241F6D",
                }}
              >
                {isActive("list") ? (
                  <img src={Hamburger} alt="" />
                ) : (
                  <img src={HamburgerBlue} alt="" />
                )}
              </Button>
            </div>
          </Col>

          <Col md={12}>
            <hr className="my-4" style={{ color: "#666666" }} />
          </Col>
          {/* <Col md={12}>
            <div className="d-flex flex-wrap justify-content-between align-items-center text-center">
              {brandData.map((brand, index) => {
                const paddingClass =
                  index === 0 || index === brandData.length - 1 ? "py-0 pe-3" : "py-2 pe-0";

                return (
                  <div key={index} className={paddingClass}>
                    <h3 className="mb-0 brandnumber">
                      {brand.percent}
                      <span className="text-muted">%</span>
                    </h3>
                    <p className="brandtext mb-0">{brand.name}</p>
                  </div>
                );
              })}
            </div>
          </Col> */}

          <Col md={12}>
            <div className="d-flex flex-wrap justify-content-between align-items-center text-center">
              {!isDashLoaded ? (
                brandData.length ? (
                  brandData?.map((brand, index) => {
                    const paddingClass =
                      index === 0 || index === brandData.length - 1
                        ? "py-0 pe-3"
                        : "py-2 pe-0";

                    return (
                      <div key={index} className={paddingClass}>
                        <h3 className="mb-0 brandnumber">
                          {brand?.comparisonPercent}
                          <span className="text-muted">%</span>
                        </h3>
                        <p className="brandtext mb-0">{brand?.brand}</p>
                      </div>
                    );
                  })
                ) : (
                  <p className="text-center w-100">No data available</p>
                )
              ) : (
                <p className="text-center w-100">
                  <Loader />
                </p>
              )}
            </div>
          </Col>

          <Col md={12}>
            <hr className="my-4" style={{ color: "#666666" }} />
          </Col>

          {isActive("list") ? (
            <>
              <Col md={12}>
                <div className="sleepwell-box">
                  <h4 className="mb-1">
                    Average Price (%) Difference (Sleepwell vs)
                  </h4>
                  <p className="mb-0">Listing View</p>
                </div>
              </Col>

              <Col md={12}>
                <div className="table-responsive dataTable mt-4">
                  <table
                    cellPadding={10}
                    cellSpacing={10}
                    style={{
                      width: "100%",
                    }}
                  >
                    <thead className="custom-header">
                      <tr>
                        <th>Material</th>
                        <th>Type</th>
                        <th>Size</th>
                        <th>Date</th>
                        <th>Max Price</th>
                        <th>Speed</th>
                        <th>Duroflex</th>
                        <th>SleepyCat</th>
                        <th>Sleepyhead</th>
                        <th>The Sleep Company</th>
                        <th>Wakelift</th>
                        <th>Kurl-on</th>
                        <th>Loom & Needles</th>
                      </tr>
                    </thead>
                    <tbody className="custom-body">
                      {!isLoading ? (
                        materialData.rows?.length ? (
                          materialData.rows?.map((key, index) => (
                            <tr key={index}>
                              <>
                                <td>{key?.material || "-"}</td>
                                <td>{key?.type || "-"}</td>
                                <td>{key?.size || "-"}</td>
                                <td>{key?.date || "-"}</td>
                                <td>{key?.maxPrice || "-"}</td>
                                <td>{key?.speed || "-"}</td>
                                <td>{key?.duroflex || "-"}</td>
                                <td>{key?.SleepyCat || "-"}</td>
                                <td>{key?.Sleepyhead || "-"}</td>
                                <td>{key?.sleepCompany || "-"}</td>
                                <td>{key?.Wakefit || "-"}</td>
                                <td>{key?.["Kurl-On"]}</td>
                                <td>{key?.["Loom & Needles"] || "-"}</td>
                              </>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={10} className="text-center">
                              No data available
                            </td>
                          </tr>
                        )
                      ) : (
                        <tr>
                          <td colSpan={10} className="text-center">
                            <Loader />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </Col>

              <Col md={12} className="mt-4">
                <Pagination
                  count={materialData.count}
                  rowsPerPage={materialData.limit}
                  page={materialData.page}
                  onPageChange={(page) =>
                    setPagination({ ...pagination, page: page + 1 })
                  }
                  onRowsPerPageChange={(page, limit) =>
                    setPagination({ ...pagination, page: 1, limit })
                  }
                />
              </Col>
            </>
          ) : (
            <>
              {isChartLoaded ? (
                <div className="text-center py-10">
                  <Loader /> {/* Replace with your actual loader component */}
                </div>
              ) : (
                grapMaterialData && (
                  <ChartComponent materialData={grapMaterialData} />
                )
              )}
            </>
          )}
        </Row>
      </Container>
    </Page>
  );
}
